<div class="col-6">
  <div class="mb-4">
    <label for="currency" class="form-label fw-bold">{{ 'GLOBAL.CURRENCY' | translate }}</label>
    <ng-select
      [items]="currencies()"
      bindLabel="name"
      bindValue="code"
      [ngModel]="currency()"
      (ngModelChange)="currency.set($event)"
      [searchable]="true"
      [closeOnSelect]="true"
      [virtualScroll]="true"
      id="currency"
      name="currency"
      class="custom w-100">
    </ng-select>
  </div>
</div>

<div class="row justify-content-start ml-1">
  @for (siteCost of siteCosts(); track siteCost; let i = $index) {
    <div class="col-6 d-flex align-items-end gap-3">
      <div class="mb-3">
        <label [for]="'cost_' + siteCost.costId" class="form-label fw-bold">{{ siteCost.name | translate }}</label>
        <input
          type="number"
          [id]="'cost_' + siteCost.costId"
          [name]="'costValue' + i"
          class="form-control"
          [(ngModel)]="siteCost.unitPrice"
          (blur)="onSiteCostBlur(siteCost)">
        </div>
      </div>
    }
  </div>

  <div class="row">
    <div class="col-3">
      <div class="providers-sidebar">
        <h6 class="fw-bold mb-3">{{ 'COST.PROVIDERS' | translate }}</h6>
        <div class="list-group">
          @for (provider of providers; track provider) {
            <button
              type="button"
              class="list-group-item list-group-item-action"
              [class.active]="selectedProvider === provider.code"
              (click)="selectProvider(provider.code)">
              {{ provider.name }}
              @if (provider.code !== 'all') {
                <small class="text-muted d-block">
                  {{ provider.code }}
                </small>
              }
            </button>
          }
        </div>
      </div>
    </div>

    <div class="col-9">
      <div #Products class="table-container">
        <div class="table-header-fixed">
          <table class="table table-striped table-hover products-table header-table">
            <colgroup>
            <col style="width: 22%">
            <col style="width: 11%">
            <col style="width: 13%">
            <col style="width: 13.5%">
            <col style="width: 13.5%">
            <col style="width: 13.5%">
            <col style="width: 13.5%">
          </colgroup>
          <thead>
            <tr>
              <th scope="col" class="title">{{ 'COST.PRODUCT' | translate }}</th>
              <th scope="col" class="title text-center">{{ 'COST.COST' | translate }}</th>
              <th scope="col" class="title text-center">{{ 'COST.DEPOT' | translate }}</th>
              <th scope="col" class="title text-center">{{ 'COST.GES_DETONATION' | translate }} (kg)</th>
              <th scope="col" class="title text-center">{{ 'COST.GES_PRODUCTION' | translate }} (kg)</th>
              <th scope="col" class="title text-center">{{ 'COST.GES_TRANSPORT' | translate }} (kg)</th>
              <th scope="col" class="title text-center">{{ 'COST.GES_TOTAL' | translate }} (kg)</th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="table-body-scrollable">
        <table class="table table-striped table-hover products-table body-table">
          <colgroup>
          <col style="width: 22%">
          <col style="width: 11%">
          <col style="width: 13%">
          <col style="width: 13.5%">
          <col style="width: 13.5%">
          <col style="width: 13.5%">
          <col style="width: 13.5%">
        </colgroup>
        <tbody>
          @for (section of productSections; track section) {
            <tr class="section-header" (click)="toggleSection(section.key)">
              <td colspan="7" class="section-title">
                <i class="fas" [class.fa-chevron-down]="sectionStates[section.key]" [class.fa-chevron-right]="!sectionStates[section.key]"></i>
                {{ section.label | translate }} ({{ getProductsBySection(section.key).length }})
              </td>
            </tr>
            @for (product of getProductsBySection(section.key); track product; let index = $index) {
              <tr
                [style.display]="sectionStates[section.key] ? 'table-row' : 'none'">
                <td class="product-name-cell">
                  <span class="product-name" [title]="product.fullname || 'N/A'">
                    {{ product.fullname || 'N/A' }}
                  </span>
                </td>
                <td class="cost-cell">
                  <div class="edit-zone">
                    @if (!isEditing(section.key, index)) {
                      <span class="text-muted">
                        {{ getProductCostValue(section.key, index) || '-' }}
                      </span>
                    }
                    @if (isEditing(section.key, index)) {
                      <input
                        type="number"
                        class="form-control form-control-sm text-center price-input"
                        [value]="getProductCostValue(section.key, index)"
                        (input)="setProductCostValue(section.key, index, $any($event.target).value)"
                        (keyup.enter)="saveProductCost(section.key, index)"
                        (blur)="onInputBlur(section.key, index)"
                        placeholder="Prix">
                    }
                    @if (!isEditing(section.key, index)) {
                      <img src="assets/icon/edit-pencil.svg"
                        alt="Modifier"
                        class="edit-icon ms-2"
                        (click)="startEditing(section.key, index)"
                        title="Edit" />
                    }
                  </div>
                </td>
                <td class="depot-cell">
                  <ng-select
                    [items]="warehouses()"
                    bindLabel="name"
                    bindValue="warehouseId"
                    [ngModel]="product.warehouseId"
                    (ngModelChange)="onWarehouseChange(product, $event)"
                    [clearable]="true"
                    [searchable]="true"
                    class="warehouse-select"
                    placeholder="-">
                  </ng-select>
                </td>
                <td class="ges-cell">
                  <span class="text-muted">{{ calculateGesDetonation(product) || '-' }}</span>
                </td>
                <td class="ges-cell">
                  <span class="text-muted">{{ calculateGesProduction(product) || '-' }}</span>
                </td>
                <td class="ges-cell">
                  <span class="text-muted">{{ calculateGesTransport(product) || '-' }}</span>
                </td>
                <td class="ges-cell">
                  <span class="text-muted fw-bold">{{ calculateTotalGes(product) || '-' }}</span>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>

